import ReglasAgrupadas from "./ReglasAgrupadas";
import api from "../../services/Api";
// src/components/Sensores/AutomatizarSensores.jsx
import { useEffect, useMemo, useState } from "react";
import sensorService from "../../services/sensorService";
import efectorService from "../../services/efectorService";
import automationService from "../../services/automationService";
import Tooltip from "../Tooltip";
import { usePermisos } from "../../context/PermisosContext";
import { isSuperAdmin } from "../../services/authUtils";

// Alineado con backend: 0=Óptimo, 1=Aceptable, 2=Crítico.
const RANGOS = [
  { value: 0, label: "Óptimo" },
  { value: 1, label: "Aceptable" },
  { value: 2, label: "Crítico" },
];

const ACCIONES = [
  { value: 1, label: "Encender" },
  { value: 2, label: "Apagar" },
];

const initialNueva = {
  sensorId: "",
  efectorId: "",
  rangoObjetivo: "",
  accion: 1,
  histeresis: "",
  minDuracionOnSeg: "",
  minDuracionOffSeg: "",
  prioridad: 0,
  estaActivo: true,
};

export default function AutomatizarSensores() {
  const { can, canEdit } = usePermisos();

  // permisos efectivos
  const esSuper = useMemo(() => !!isSuperAdmin(), []);
  // ❗ FIX: usar las claves reales definidas en permisos.js
  const puedeVer = esSuper || !!can?.("AUTOMATIZACION_VIEW");
  const puedeEditar = esSuper || !!canEdit?.("AUTOMATIZACION_EDIT");

  const [allEstructura, setAllEstructura] = useState([]);
  const [estanques, setEstanques] = useState([]);
  const [efectores, setEfectores] = useState([]);
  const [estanqueId, setEstanqueId] = useState("");
  const [sensorId, setSensorId] = useState("");
  const [sensoresDelEstanque, setSensoresDelEstanque] = useState([]);

  const [valRef, setValRef] = useState(null);
  const [reglas, setReglas] = useState([]);
  const [nueva, setNueva] = useState(initialNueva);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [busquedaReglas, setBusquedaReglas] = useState("");
  const [verArchivadas, setVerArchivadas] = useState(false);
  const reglasFiltradas = useMemo(() => {
    const q = busquedaReglas.trim().toLocaleLowerCase("es");
    if (!q) return reglas;
    return reglas.filter((r) => {
      const efectorIdRegla = r.efectorId ?? r.EfectorId;
      const efector = efectores.find((e) => String(e.id ?? e.Id) === String(efectorIdRegla));
      return JSON.stringify({ ...r, efector: efector?.nombre ?? efector?.Nombre ?? "" })
        .toLocaleLowerCase("es").includes(q);
    });
  }, [reglas, efectores, busquedaReglas]);

  // Edición inline
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({
    efectorId: "",
    rangoObjetivo: "",
    accion: 1,
    histeresis: "",
    minDuracionOnSeg: "",
    minDuracionOffSeg: "",
    prioridad: 0,
  estaActivo: true,
  });

  const [diagnostico, setDiagnostico] = useState(null);
  useEffect(() => {
    const id = editId ? editForm.efectorId : nueva.efectorId;
    if (!id) { setDiagnostico(null); return; }
    let vigente = true;
    api.get(`/Automatizacion/diagnostico/${id}`).then(({data}) => { if(vigente) setDiagnostico(data); }).catch(() => {if(vigente) setDiagnostico(null);});
    return () => {vigente=false;};
  }, [nueva.efectorId, editId, editForm.efectorId, reglas]);

  const token = localStorage.getItem("token");

  // Cargar estructura base (estanques/sensores) solo si puede ver
  useEffect(() => {
    if (!puedeVer) return;
    (async () => {
      try {
        const estructura = await sensorService.obtenerTodosSensores();
        setAllEstructura(estructura || []);
        const ests = (estructura || []).map((e) => ({
          id: e.estanqueId ?? e.EstanqueId,
          nombre: e.estanqueNombre ?? e.EstanqueNombre,
        }));
        setEstanques(ests);
      } catch (e) {
        console.error(e);
        alert("No se pudo cargar la lista de estanques.");
      }
    })();
  }, [puedeVer]);

  // Cargar sensores/efectores del estanque
  useEffect(() => {
    if (!puedeVer) return;

    (async () => {
      setEfectores([]);
      setSensoresDelEstanque([]);
      setSensorId("");
      setEditId(null);

      if (!estanqueId) return;

      try {
        const nodoEstanque = (allEstructura || []).find(
          (e) => String(e.estanqueId ?? e.EstanqueId) === String(estanqueId)
        );

        const dispositivos = nodoEstanque
          ? (nodoEstanque.dispositivos ?? nodoEstanque.Dispositivos ?? [])
          : [];

        const sensores = [];
        dispositivos.forEach((d) => {
          const dId = d.dispositivoId ?? d.DispositivoId;
          (d.sensores ?? d.Sensores ?? []).forEach((s) => {
            sensores.push({
              id: s.id ?? s.Id,
              nombre: s.nombre ?? s.Nombre,
              tipoParametroId: s.tipoParametroId ?? s.TipoParametroId,
              pinRx: s.pinRx ?? s.PinRx,
              pinTx: s.pinTx ?? s.PinTx,
              dispositivoId: dId,
            });
          });
        });
        setSensoresDelEstanque(sensores);

        const todos = await efectorService.obtenerTodosLosEfectores(token);
        const efectoresFiltrados = []
          .concat(
            ...(todos || []).flatMap((e) =>
              (e.dispositivos || []).map((d) => ({
                EstanqueId: e.estanqueId ?? e.EstanqueId,
                EstanqueNombre: e.estanqueNombre,
                DispositivoId: d.dispositivoId,
                Efectores: d.efectores || [],
              }))
            )
          )
          .filter((x) => String(x.EstanqueId ?? estanqueId) === String(estanqueId))
          .flatMap((x) =>
            x.Efectores.map((f) => ({
              id: f.id ?? f.Id,
              nombre: f.nombre ?? f.Nombre,
              dispositivoId: x.DispositivoId,
              descripcion: f.descripcion ?? "",
              tipoEfectorId: f.tipoEfectorId ?? f.TipoEfectorId,
              pinActivacion: f.pinActivacion ?? f.PinActivacion,
            }))
          );

        const dispIdsDelEstanque = new Set(
          dispositivos.map((d) => d.dispositivoId ?? d.DispositivoId)
        );
        const finalEfectores =
          efectoresFiltrados.length > 0
            ? efectoresFiltrados
            : (todos || [])
                .flatMap((e) =>
                  (e.dispositivos || []).map((d) =>
                    (d.efectores || []).map((f) => ({
                      id: f.id ?? f.Id,
                      nombre: f.nombre ?? f.Nombre,
                      dispositivoId: d.dispositivoId,
                    }))
                  )
                )
                .flat()
                .filter((f) => dispIdsDelEstanque.has(f.dispositivoId));

        setEfectores(finalEfectores || []);
      } catch (e) {
        console.error(e);
        alert("No se pudo cargar efectores/sensores del estanque.");
      }
    })();
  }, [puedeVer, estanqueId, allEstructura, token]);

  // Cargar reglas/valores de referencia al elegir sensor
  useEffect(() => {
    if (!puedeVer) return;

    (async () => {
      setValRef(null);
      setNueva((f) => ({ ...initialNueva, sensorId }));
      setEditId(null);



      try {
        setLoading(true);

        const reglasSrv = await automationService.listarReglas(sensorId || undefined, { estanqueId, archivadas: verArchivadas });
        setReglas(reglasSrv || []);

        if (!sensorId) return;

        const sensorSel = sensoresDelEstanque.find(
          (s) => String(s.id) === String(sensorId)
        );
        const tipoParamId = sensorSel?.tipoParametroId;

        if (tipoParamId) {
          try {
            const vr = await automationService.obtenerValorReferenciaPorTipo(
              tipoParamId, sensorId
            );
            setValRef(
              vr
                ? {
                    unidad: vr.unidad ?? vr.Unidad,
                    optimoMin: vr.optimoMin ?? vr.OptimoMin,
                    optimoMax: vr.optimoMax ?? vr.OptimoMax,
                    aceptableMin: vr.aceptableMin ?? vr.AceptableMin,
                    aceptableMax: vr.aceptableMax ?? vr.AceptableMax,
                    criticoMin: vr.criticoMin ?? vr.CriticoMin,
                    criticoMax: vr.criticoMax ?? vr.CriticoMax,
                  }
                : null
            );
          } catch {
            setValRef(null);
          }
        }
      } catch (e) {
        console.error(e);
        alert("No se pudieron cargar reglas/valores de referencia.");
      } finally {
        setLoading(false);
      }
    })();
  }, [puedeVer, sensorId, estanqueId, sensoresDelEstanque, verArchivadas]);

  const recargarReglas = async (sid = sensorId) => {
    const actualizadas = await automationService.listarReglas(sid || undefined, { estanqueId, archivadas: verArchivadas });
    setReglas(actualizadas || []);
  };

  const sensoresAgrupados = useMemo(() => {
    const map = new Map();
    sensoresDelEstanque.forEach((s) => {
      const key = s.dispositivoId;
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(s);
    });
    return Array.from(map.entries());
  }, [sensoresDelEstanque]);

  const handleNuevaChange = (e) => {
    if (!puedeEditar) return;
    const { name, value } = e.target;
    setNueva((f) => ({ ...f, [name]: value }));
  };

  const handleCrearRegla = async (e) => {
    e.preventDefault();
    if (!puedeEditar) return;

    if (!nueva.sensorId || !nueva.efectorId || nueva.rangoObjetivo === "" || !nueva.accion) {
      alert("Completa los campos obligatorios.");
      return;
    }

    setSaving(true);
    try {
      const payload = {
        sensorId: Number(nueva.sensorId),
        prioridad: Number(nueva.prioridad),
        efectorId: Number(nueva.efectorId),
        rangoObjetivo: Number(nueva.rangoObjetivo),
        accion: Number(nueva.accion),
        histeresis: nueva.histeresis !== "" ? Number(nueva.histeresis) : null,
        minDuracionOnSeg: nueva.minDuracionOnSeg !== "" ? Number(nueva.minDuracionOnSeg) : null,
        minDuracionOffSeg: nueva.minDuracionOffSeg !== "" ? Number(nueva.minDuracionOffSeg) : null,
        estaActivo: true,
      };
      await automationService.crearRegla(payload);
      await recargarReglas(nueva.sensorId);
      setNueva((f) => ({ ...initialNueva, sensorId: nueva.sensorId }));
    } catch (err) {
      console.error(err);
      alert(err?.response?.data ?? "No se pudo crear la regla.");
    } finally {
      setSaving(false);
    }
  };

  const onToggle = async (id) => {
    if (!puedeEditar) return;
    try {
      await automationService.toggleRegla(id);
      await recargarReglas();
    } catch (e) {
      console.error(e);
      alert("No se pudo cambiar el estado de la regla.");
    }
  };

  const onArchivar = async (id) => {
    if (!puedeEditar) return;
    if (!window.confirm("¿Archivar la regla? Dejará de ejecutarse y podrás recuperarla después.")) return;
    try {
      await automationService.archivarRegla(id);
      await recargarReglas();
    } catch (e) {
      console.error(e);
      alert("No se pudo archivar la regla.");
    }
  };

  const onRecuperar = async (id) => {
    if (!puedeEditar) return;
    try { await automationService.recuperarRegla(id); await recargarReglas(); }
    catch (e) { console.error(e); alert(e?.response?.data ?? "No se pudo recuperar la regla."); }
  };

  // Edición inline
  const startEdit = (r) => {
    if (!puedeEditar) return;

    const id = r.id ?? r.Id;

    const efectorId = r.efectorId ?? r.EfectorId ?? "";
    const rangoObjetivo = r.rangoObjetivo ?? r.RangoObjetivo ?? 0;
    const accion = r.accion ?? r.Accion ?? 1;

    const hVal = r.histeresis ?? r.Histeresis;
    const minOn = r.minDuracionOnSeg ?? r.MinDuracionOnSeg;
    const minOff = r.minDuracionOffSeg ?? r.MinDuracionOffSeg;

    const estaActivo = (r.estaActivo ?? r.EstaActivo) ?? false;

    setEditId(id);
    setEditForm({
      sensorId: r.sensorId ?? r.SensorId,
      efectorNombre: r.efectorNombre ?? r.EfectorNombre,
      efectorId: String(efectorId),
      prioridad: r.prioridad ?? 0,
      rangoObjetivo: Number(rangoObjetivo),
      accion: Number(accion),
      histeresis: hVal != null ? String(hVal) : "",
      minDuracionOnSeg: minOn != null ? String(minOn) : "",
      minDuracionOffSeg: minOff != null ? String(minOff) : "",
      estaActivo,
    });
  };

  const cancelEdit = () => setEditId(null);

  const handleEditChange = (e) => {
    if (!puedeEditar) return;
    const { name, value, type, checked } = e.target;
    setEditForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const saveEdit = async () => {
    if (!puedeEditar) return;
    try {
      const payload = {
        sensorId: Number(editForm.sensorId),
        prioridad: Number(editForm.prioridad),
        efectorId: Number(editForm.efectorId),
        rangoObjetivo: Number(editForm.rangoObjetivo),
        accion: Number(editForm.accion),
        histeresis: editForm.histeresis !== "" ? Number(editForm.histeresis) : null,
        minDuracionOnSeg: editForm.minDuracionOnSeg !== "" ? Number(editForm.minDuracionOnSeg) : null,
        minDuracionOffSeg: editForm.minDuracionOffSeg !== "" ? Number(editForm.minDuracionOffSeg) : null,
        estaActivo: !!editForm.estaActivo,
      };
      await automationService.actualizarRegla(editId, payload);
      await recargarReglas();
      setEditId(null);
    } catch (e) {
      console.error(e);
      alert(e?.response?.data ?? "No se pudo guardar la regla.");
    }
  };

  // Tooltips
  const TT_HISTERESIS =
    "Evita oscilaciones de encendido/apagado cerca del límite. Ej.: con 0.10 se apaga recién al superar el valor objetivo + 0.10.";
  const TT_MIN_ON =
    "Tiempo mínimo que el efector permanece ENCENDIDO una vez activado.";
  const TT_MIN_OFF =
    "Tiempo mínimo que el efector permanece APAGADO una vez desactivado.";

  if (!puedeVer) {
    return (
      <div className="bg-neutral-950 text-neutral-300 p-6 rounded-lg max-w-4xl mx-auto">
        No tienes permisos para ver Automatizaciones por Sensores.
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold text-emerald-400">Automatizar Sensores</h1>
          <p className="text-sm text-gray-300">
            Define reglas para encender/apagar efectores según el valor del sensor.
          </p>
        </div>
        {esSuper && (
          <span className="text-xs border border-emerald-500/60 px-2 py-1 rounded text-emerald-300">
            Superadministrador
          </span>
        )}
      </div>

      {/* Filtros */}
      <div className="bg-[#111319] rounded-2xl p-4 border border-[#232635] mb-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div>
            <label className="text-sm text-gray-300">Estanque</label>
            <select
              className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
              value={estanqueId}
              onChange={(e) => setEstanqueId(e.target.value)}
            >
              <option value="">Seleccione…</option>
              {estanques.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="md:col-span-2">
            <label className="text-sm text-gray-300">Sensor</label>
            <select
              className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
              value={sensorId}
              onChange={(e) => setSensorId(e.target.value)}
              disabled={!estanqueId}
            >
              <option value="">
                {estanqueId ? "Seleccione…" : "Elige un estanque primero"}
              </option>
              {sensoresAgrupados.map(([dispId, arr]) => (
                <optgroup key={dispId} label={`Dispositivo #${dispId}`}>
                  {arr.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.nombre} (Tipo {s.tipoParametroId}) — {s.pinRx}/{s.pinTx}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Rangos de referencia */}
      {sensorId && (
        <div className="bg-[#0F1320] rounded-2xl p-4 border border-[#232635] mb-4">
          <h3 className="text-emerald-400 font-semibold mb-2">Valores de Referencia</h3>
          {valRef ? (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm text-gray-200">
              <div className="bg-[#0C0F16] p-3 rounded-xl border border-[#2C2F40]">
                <div className="font-semibold text-violet-300 mb-1">Óptimo</div>
                <div>{valRef.optimoMin} – {valRef.optimoMax} {valRef.unidad}</div>
              </div>
              <div className="bg-[#0C0F16] p-3 rounded-xl border border-[#2C2F40]">
                <div className="font-semibold text-violet-300 mb-1">Aceptable</div>
                <div>{valRef.aceptableMin} – {valRef.aceptableMax} {valRef.unidad}</div>
              </div>
              <div className="bg-[#0C0F16] p-3 rounded-xl border border-[#2C2F40]">
                <div className="font-semibold text-violet-300 mb-1">Crítico</div>
                <div>
                  &lt; {valRef.criticoMin} {valRef.unidad} &nbsp; | &nbsp; &gt; {valRef.criticoMax} {valRef.unidad}
                </div>
              </div>
            </div>
          ) : (
            <p className="text-gray-400 text-sm">
              No se encontraron rangos para este tipo de parámetro.
            </p>
          )}
        </div>
      )}

      {/* Crear nueva regla */}
      <form onSubmit={handleCrearRegla} className="bg-[#111319] rounded-2xl p-4 border border-[#232635] mb-4">
        <h3 className="text-emerald-400 font-semibold mb-3">Crear nueva regla</h3>
        <p>Cuando el sensor #{sensorId || '…'} entre en {RANGOS.find(r=>r.value===Number(nueva.rangoObjetivo))?.label || 'el rango elegido'}, {Number(nueva.accion)===1?'encender':'apagar'} el efector #{nueva.efectorId || '…'}. Los límites y unidades aparecen arriba.</p>
        <label>Prioridad (0–100, gana la mayor) <input type="number" min="0" max="100" name="prioridad" value={nueva.prioridad} onChange={handleNuevaChange} disabled={!puedeEditar} className="bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2" /></label>
        {diagnostico && <div className="my-3 text-sm"><p>{diagnostico.prioridad}</p><p>{diagnostico.sinLectura}</p><p>Posibles conflictos: {diagnostico.reglas.length} reglas de sensores, {diagnostico.horarios} horarios, {diagnostico.alarmas} alarmas para esta salida. Revisa las acciones opuestas antes de guardar.</p><p>Última acción: {diagnostico.ultimo ? `${diagnostico.ultimo.fechaHora} UTC · ${diagnostico.ultimo.origen} · ${diagnostico.ultimo.comentario || 'Sin motivo histórico'}` : 'Sin ejecuciones registradas'}</p></div>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div>
            <label className="text-sm text-gray-300">Efector</label>
            <select
              name="efectorId"
              value={nueva.efectorId}
              onChange={handleNuevaChange}
              disabled={!sensorId || !puedeEditar}
              className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
              required
            >
              <option value="">Seleccione…</option>
              {efectores.map((e) => (
                <option key={(e.id ?? e.Id)} value={(e.id ?? e.Id)}>
                  #{(e.id ?? e.Id)} — {(e.nombre ?? e.Nombre)} (Disp {(e.dispositivoId ?? e.DispositivoId)})
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm text-gray-300">Rango objetivo</label>
            <select
              name="rangoObjetivo"
              value={nueva.rangoObjetivo}
              onChange={handleNuevaChange}
              disabled={!sensorId || !puedeEditar}
              className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
              required
            >
              <option value="">Seleccione…</option>
              {RANGOS.map((r) => (
                <option key={r.value} value={r.value}>{r.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm text-gray-300">Acción</label>
            <select
              name="accion"
              value={nueva.accion}
              onChange={handleNuevaChange}
              disabled={!sensorId || !puedeEditar}
              className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
              required
            >
              {ACCIONES.map((a) => (
                <option key={a.value} value={a.value}>{a.label}</option>
              ))}
            </select>
          </div>

          {/* Histeresis */}
          <Tooltip text={TT_HISTERESIS}>
            <div>
              <label className="text-sm text-gray-300 cursor-help">
                Histeresis (opcional) <span aria-hidden>ℹ️</span>
              </label>
              <input
                name="histeresis"
                value={nueva.histeresis}
                onChange={handleNuevaChange}
                type="number"
                step="0.01"
                disabled={!puedeEditar}
                className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                placeholder="Ej. 0.10"
              />
            </div>
          </Tooltip>

          {/* Min ON */}
          <Tooltip text={TT_MIN_ON}>
            <div>
              <label className="text-sm text-gray-300 cursor-help">
                Mín. ON (seg) <span aria-hidden>ℹ️</span>
              </label>
              <input
                name="minDuracionOnSeg"
                value={nueva.minDuracionOnSeg}
                onChange={handleNuevaChange}
                type="number"
                min="0"
                step="1"
                disabled={!puedeEditar}
                className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                placeholder="0"
              />
            </div>
          </Tooltip>

          {/* Min OFF */}
          <Tooltip text={TT_MIN_OFF}>
            <div>
              <label className="text-sm text-gray-300 cursor-help">
                Mín. OFF (seg) <span aria-hidden>ℹ️</span>
              </label>
              <input
                name="minDuracionOffSeg"
                value={nueva.minDuracionOffSeg}
                onChange={handleNuevaChange}
                type="number"
                min="0"
                step="1"
                disabled={!puedeEditar}
                className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                placeholder="0"
              />
            </div>
          </Tooltip>
        </div>

        <div className="mt-4 flex gap-3">
          <button
            type="submit"
            disabled={!sensorId || saving || !puedeEditar}
            className={`px-5 py-2 rounded-xl font-semibold text-white shadow ${
              !sensorId || saving || !puedeEditar ? "bg-gray-600 cursor-not-allowed" : "bg-violet-600 hover:bg-violet-700"
            }`}
          >
            {saving ? "Guardando…" : "Crear regla"}
          </button>
          <button
            type="button"
            onClick={() => puedeEditar && setNueva((f) => ({ ...initialNueva, sensorId }))}
            disabled={!puedeEditar}
            className="px-5 py-2 rounded-xl border border-[#2C2F40] text-gray-200 hover:bg-[#151826] disabled:opacity-60"
          >
            Limpiar
          </button>
        </div>
      </form>

      {/* Reglas configuradas */}
      <div className="bg-[#111319] rounded-2xl p-4 border border-[#232635] mb-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-emerald-400 font-semibold">{sensorId ? "Reglas del sensor seleccionado" : estanqueId ? "Reglas del estanque" : "Todas mis reglas por sensor"}</h3>
          <div className="flex items-center gap-3">{loading && <span className="text-xs text-gray-400">cargando…</span>}<button type="button" className="px-3 py-2 rounded-lg border border-[#2C2F40] text-sm" onClick={() => setVerArchivadas(v => !v)}>{verArchivadas ? "Ver vigentes" : "Ver archivadas"}</button></div>
        </div>

        <input value={busquedaReglas} onChange={(e) => setBusquedaReglas(e.target.value)}
          placeholder="Buscar reglas por efector, rango, acción o estado…"
          className="w-full mb-3 bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2" />

        {reglasFiltradas.length === 0 ? (
          <div className="text-gray-400 text-sm">{loading ? "Cargando reglas…" : verArchivadas ? "No hay reglas archivadas que coincidan." : "No hay reglas que coincidan con los filtros."}</div>
        ) : (
          <ReglasAgrupadas reglas={reglasFiltradas} tipo="sensores">
            {(r) => {
              const id = r.id ?? r.Id;
              const estaActivo = (r.estaActivo ?? r.EstaActivo) ?? false;
              const archivada = !!(r.archivadoUtc ?? r.ArchivadoUtc);

              if (editId === id) {
                // Vista de edición
                return (
                  <div
                    key={id}
                    className="rounded-xl border border-[#2C2F40] bg-[#0C0F16] p-3"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                      <div>
                        <label className="text-sm text-gray-300">Efector</label>
                        <select
                          name="efectorId"
                          value={editForm.efectorId}
                          onChange={handleEditChange}
                          disabled={!puedeEditar}
                          className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                        >
                          <option value="">Seleccione…</option>
                          {!efectores.some(e => String(e.id ?? e.Id) === String(editForm.efectorId)) && <option value={editForm.efectorId}>{editForm.efectorNombre || `Efector #${editForm.efectorId}`}</option>}
                          {efectores.map((e) => (
                            <option key={(e.id ?? e.Id)} value={(e.id ?? e.Id)}>
                              #{(e.id ?? e.Id)} — {(e.nombre ?? e.Nombre)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="text-sm text-gray-300">Rango objetivo</label>
                        <select
                          name="rangoObjetivo"
                          value={editForm.rangoObjetivo}
                          onChange={handleEditChange}
                          disabled={!puedeEditar}
                          className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                        >
                          {RANGOS.map((rr) => (
                            <option key={rr.value} value={rr.value}>{rr.label}</option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="text-sm text-gray-300">Acción</label>
                        <select
                          name="accion"
                          value={editForm.accion}
                          onChange={handleEditChange}
                          disabled={!puedeEditar}
                          className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                        >
                          {ACCIONES.map((a) => (
                            <option key={a.value} value={a.value}>{a.label}</option>
                          ))}
                        </select>
                      </div>

                      <Tooltip text={TT_HISTERESIS}>
                        <div>
                          <label className="text-sm text-gray-300 cursor-help">
                            Histeresis <span aria-hidden>ℹ️</span>
                          </label>
                          <input
                            name="histeresis"
                            value={editForm.histeresis}
                            onChange={handleEditChange}
                            type="number"
                            step="0.01"
                            disabled={!puedeEditar}
                            className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                            placeholder="Ej. 0.10"
                          />
                        </div>
                      </Tooltip>

                      <Tooltip text={TT_MIN_ON}>
                        <div>
                          <label className="text-sm text-gray-300 cursor-help">
                            Mín. ON (seg) <span aria-hidden>ℹ️</span>
                          </label>
                          <input
                            name="minDuracionOnSeg"
                            value={editForm.minDuracionOnSeg}
                            onChange={handleEditChange}
                            type="number"
                            min="0"
                            step="1"
                            disabled={!puedeEditar}
                            className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                            placeholder="0"
                          />
                        </div>
                      </Tooltip>

                      <Tooltip text={TT_MIN_OFF}>
                        <div>
                          <label className="text-sm text-gray-300 cursor-help">
                            Mín. OFF (seg) <span aria-hidden>ℹ️</span>
                          </label>
                          <input
                            name="minDuracionOffSeg"
                            value={editForm.minDuracionOffSeg}
                            onChange={handleEditChange}
                            type="number"
                            min="0"
                            step="1"
                            disabled={!puedeEditar}
                            className="mt-1 w-full bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2"
                            placeholder="0"
                          />
                        </div>
                      </Tooltip>

                      <div className="flex items-end">
                        <label className="inline-flex items-center gap-2 text-sm text-gray-200">
                          <input
                            type="checkbox"
                            name="estaActivo"
                            checked={!!editForm.estaActivo}
                            onChange={handleEditChange}
                            disabled={!puedeEditar}
                          />
                          Activa
                        </label>
                      </div>
                    </div>

                    <label>Prioridad (0–100) <input type="number" min="0" max="100" name="prioridad" value={editForm.prioridad} onChange={handleEditChange} disabled={!puedeEditar} className="bg-[#0C0F16] text-gray-100 border border-[#2C2F40] rounded-xl px-3 py-2" /></label>
                    <div className="mt-3 flex gap-2">
                      <button
                        onClick={saveEdit}
                        disabled={!puedeEditar}
                        className="px-4 py-2 rounded-lg bg-violet-600 hover:bg-violet-700 text-white font-semibold disabled:opacity-60"
                      >
                        Guardar
                      </button>
                      <button
                        onClick={cancelEdit}
                        className="px-4 py-2 rounded-lg border border-[#2C2F40] text-gray-200 hover:bg-[#151826]"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                );
              }

              // Vista normal
              const efectorId = r.efectorId ?? r.EfectorId;
              const rangoObjetivo = r.rangoObjetivo ?? r.RangoObjetivo;
              const accion = r.accion ?? r.Accion;
              const histeresis = r.histeresis ?? r.Histeresis;
              const minOn = r.minDuracionOnSeg ?? r.MinDuracionOnSeg;
              const minOff = r.minDuracionOffSeg ?? r.MinDuracionOffSeg;

              return (
                <div
                  key={id}
                  className="rounded-xl border border-[#2C2F40] bg-[#0C0F16] p-3 flex items-center justify-between"
                >
                  <div className="text-gray-200 text-sm">
                    <div className="font-semibold">
                      {r.sensorNombre || `Sensor #${r.sensorId}`} → {r.efectorNombre || `Efector #${efectorId}`} · Prioridad {r.prioridad ?? 0} · {RANGOS.find((x) => x.value === Number(rangoObjetivo))?.label} →{" "}
                      {ACCIONES.find((x) => x.value === Number(accion))?.label}
                    </div>
                    <div className="text-gray-400">
                      Histeresis: {histeresis ?? "—"} · Min ON: {minOn ?? "—"}s · Min OFF: {minOff ?? "—"}s
                    </div>
                  </div>
                  <div className="flex gap-2">
                    {archivada ? <button onClick={() => onRecuperar(id)} disabled={!puedeEditar} className="px-3 py-1 rounded-lg text-xs font-semibold bg-emerald-700 text-white disabled:opacity-60">Recuperar</button> : <><button
                      onClick={() => startEdit(r)}
                      disabled={!puedeEditar}
                      className="px-3 py-1 rounded-lg text-xs font-semibold bg-sky-600 hover:bg-sky-700 text-white disabled:opacity-60"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => onToggle(id)}
                      disabled={!puedeEditar}
                      className={`px-3 py-1 rounded-lg text-xs font-semibold ${
                        estaActivo
                          ? "bg-emerald-600 hover:bg-emerald-700 text-white"
                          : "bg-gray-600 hover:bg-gray-700 text-white"
                      } disabled:opacity-60`}
                    >
                      {estaActivo ? "Activo" : "Inactivo"}
                    </button>
                    <button
                      onClick={() => onArchivar(id)}
                      disabled={!puedeEditar}
                      className="px-3 py-1 rounded-lg text-xs font-semibold bg-amber-700 hover:bg-amber-800 text-white disabled:opacity-60"
                    >
                      Archivar
                    </button></>}
                  </div>
                </div>
              );
            }}
          </ReglasAgrupadas>
        )}
      </div>

    </div>
  );
}
